module.exports = __webpack_public_path__ + "static/media/training_lp_hero.1a67d2e9.png";